<template>
    <sa-page-layout ref="SaplPostiLettoPianiView" :btnRouterBackVisible="true" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource">
        <!-- <template slot="table-filter">
			<ras-configurazione-posti-letto-piani-view-component
				ref="cmpRasConfigurazionePostiLettoPianiView"
				:showModalLoading="showModalLoading"
				@errorRestCall="onError"
				@update="onUpdateJsonData"
				@beforeLoadData="onBeforeLoadData"
				@afterLoadData="onAfterLoadData"
			></ras-configurazione-posti-letto-piani-view-component>
		</template> -->

        <template slot="table-body">
            <ras-configurazione-laboratorio-view-component ref="cmpRasConfigurazioneLaboratorioView" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RasConfigurazioneLaboratorioViewComponent from "../components/RasConfigurazioneLaboratorioViewComponent.vue";
export default {
    components: { SaPageLayout, RasConfigurazioneLaboratorioViewComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsalaboratori",
            id: null,
            jsonData: {},
        };
    },
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpRasConfigurazioneLaboratorioView.init(me.id);
        },

        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onError(errorData) {
            let me = this;
            me.$refs.SaplPostiLettoPianiView.showModalError(errorData);
        },
    },
};
</script>

<style></style>
